import {
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Box
  } from '@mui/material'
import { keyframes } from '@mui/system';
import { globalStateContext, dispatchStateContext } from '../App.js';
import React from 'react';
const blink = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;
const useGlobalState = () => [
    React.useContext(globalStateContext),
    React.useContext(dispatchStateContext)
  ];

const StatsMUI = (props) => {
    const { stats, categories, updatedStats, liveitems, colours, chartIndex} = props
    const [state, dispatch] = useGlobalState();
    if(!stats){
        return(<></>)
    }
    if(!updatedStats){
        return(<></>)
    }
    const rows = categories.map((category)=>{
        if(!stats[category.datakey]){

            return null
        }
        let target = NaN;
        for (let item of state.data) {
            for (let cat of item.categories) {
                if (cat.datakey === category.datakey) {
                    target = cat.targets.target;
                }
            }
        }
        var numDigits = 2
        if (category.name=="Temperature (F)"||category.name=="Temperature (C)"){
            numDigits = 1
        }
        if (category.name=='Density Vertical PPG'||category.name=='Density Vertical PPG'||category.name=='Density Coriolis'||category.name=='Density Vertical'){
            numDigits =3
        }
       return {
        //to change nr of digits shown, change toFixed value, set to fixed valeue based on name to change based on tag
        name:category.name,
        datakey: category.datakey,
        average:(stats[category.datakey].Sum / stats[category.datakey].Count).toFixed(2),
        min:stats[category.datakey].Min.toFixed(2), 
        max:stats[category.datakey].Max.toFixed(2),
        target:target,
        current: stats[category.datakey].Current.toFixed(2),
    }
    });

    if(!rows[0]){
        return(<>
        </>)
    }
    return(<>
    <TableContainer component={Box} sx={{width:'76%', ml:3}}>
        <Table size='small' sx={{height:150}}>
            <TableHead>
                <TableRow style={{height:35}}>
                    <TableCell align="left" sx={{color: 'white', p:0, m:0, width: "30%"}}>Category</TableCell>
                    <TableCell align="center" sx={{color: 'white', p:0, m:0, width: "17.5%"}}>Avg</TableCell>
                    <TableCell align="center" sx={{color: 'white', p:0, m:0,width: "17,5%"}}>Min</TableCell>
                    <TableCell align="center" sx={{color: 'white', p:0, m:0,width: "17.5%"}}>Max</TableCell>
                    <TableCell align="center" sx={{color: 'white', p:0, m:0,width: "17.5%"}}>Current</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
               { rows.map((row,index)=>{
                if(row){
                    if (row.name === "Temperature (C)") {
                        row.name = "Temp C°"
                       };
                       if (row.name === "Specific Gravity") {
                        row.name = "SG"
                       };
                        if (row.name === "Density Vertical") {
                            row.name = "Vertical (SG)"
                        }
                        if (row.name === "Density Vertical PPG") {
                            row.name = "Vertical (PPG)"
                        }
                        if (row.name === "Density Coriolis") {
                            row.name = "Coriolis (SG)"
                        }
                       if (row.name === "Plastic Viscosity") {
                        row.name = "PV"
                       };
                       if (row.name === "Yield Point") {
                        row.name = "YP"
                       };
                       if (row.name === "Plastic Viscosity api") {
                        row.name = "PV(cP)"
                       }
                       if (row.name === "Yield Point api") {
                        row.name = "YP(lb/100ft2)"
                       }
                       if (row.name === "3 RPM api") {
                        row.name = "3 RPM"
                       }
                        if (row.name === "6 RPM api") {
                            row.name = "6 RPM"
                        }
                        if (row.name === "100 RPM api") {
                            row.name = "100 RPM"

                        }
                        if (row.name === "200 RPM api") {
                            row.name = "200 RPM"
                        }
                        if (row.name === "300 RPM api") {
                            row.name = "300 RPM"
                        }
                        if (row.name === "600 RPM api") {
                            row.name = "600 RPM"
                        }
                       let isGreen = true;
                       if (Math.abs(row.current-row.target) > 2) {
                        isGreen = false;
                       }
                       if (!updatedStats[row.datakey]) {
                        updatedStats[row.datakey] = {
                            average: true,
                            min: true,
                            max: true,
                        };
                       }
                        return( 
                        <TableRow key={row.name} style={{height:33}} >
                            <TableCell align="left" sx={{color: colours[index+chartIndex], p:0, m:0}}>{row.name}</TableCell>
                            <TableCell align="center" sx={{color: 'white', p:0, m:0, animation: updatedStats[row.datakey].average ? `${blink} 1.5s linear` : '0s linear',width: "20%"}}>{row.average} </TableCell>
                            <TableCell align="center" sx={{color: 'white', p:0, m:0, animation: updatedStats[row.datakey].min ? `${blink} 1.5s linear` : '0s linear',width: "20%"}}>{row.min} </TableCell>
                            <TableCell align="center" sx={{color: 'white', p:0, m:0, animation: updatedStats[row.datakey].max ? `${blink} 1.5s linear` : '0s linear',width: "20%"}}>{row.max} </TableCell>
                            {isNaN(row.target) 
                                ?  <TableCell align="center" sx={{color: 'white', p:0, m:0, animation: `${blink} 1.5s linear`,width: "20%"}}>{row.current} </TableCell>
                                : <TableCell align="center" sx={{color: isGreen ? 'green' : 'red', p:0, m:0, animation: `${blink} 1.5s linear`,width: "20%"}}>{row.current} </TableCell>
                            }
                        </TableRow>)
                }
               
               
                })}
            </TableBody>
        </Table>
    </TableContainer>
    
    </>
    )}

export default StatsMUI

